import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { TWStaticSubscribeCard } from '../../cards/TWStaticSubscribeCard/TWStaticSubscribeCard'

export const StaticSubscribePromoCardRegistration = createRegisterableComponent(
    'tw-subscribe-promo-card',
    (props) => <TWStaticSubscribeCard options={props} />,
)
